import { useRouter } from 'next/router'
import React from 'react'
import clsx from 'clsx'
import Head from 'next/head'

import { HeaderBar, HeaderBarLeftAction } from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/fe-toolbox'
import { Icon } from '@wartek-id/icon'

import { WithLayoutListener } from 'components/Layout/Desktop/DesktopLayout'
import { ModulPage as ModulIndexPage } from 'app/PelatihanMandiriPage/ModulPage'

const fauxHeaderBg =
  'before:absolute before:h-14 before:w-full before:top-0 before:bg-expressive-dark-blue before:z-0 z-10'

const ModulePage = (props) => {
  const { isDesktopScreenSize } = props
  const router = useRouter()
  const { query } = router

  return (
    <WithLayoutListener isDesktop={isDesktopScreenSize}>
      <Head>
        <title>Pelatihan Mandiri | Topik {query.topik_name ?? ''}</title>
      </Head>
      <ModulIndexPage isDesktop={isDesktopScreenSize} />
    </WithLayoutListener>
  )
}

const PageHeader = () => {
  const router = useRouter()
  return (
    <HeaderBar inverse fixed variant="transparent" className={fauxHeaderBg}>
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="inverse">
            arrow_back
          </Icon>
        }
        onClick={() => historyUtils.backToApp(router.back)}
      />
    </HeaderBar>
  )
}

ModulePage.layoutOpts = {
  hasHeader: true,
  className: clsx(fauxHeaderBg, 'before:-mt-14'),
  header: PageHeader,
  enableDesktopLayout: true,
}

export default ModulePage
